import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../../actions/actionTypes";
import {
  InitAction,
  PettyCashAction,
  PettyCashierPettyCashAction
} from "../../actions";
import * as PettyCashApi from "../../api/pettyCash/pettyCashierPettyCash";
import { toastr } from "react-redux-toastr";
import { goBack, push, replace } from "connected-react-router";
import { createBrowserHistory } from "history";
import checkErrorMessagesExist from "../../assets/checkErrorMessagesExist";
import {
  PETTY_CASH_PETTY_CASHIER,
  SUMMARY_PETTY_CASH_PETTY_CASHIER
} from "../../constants/urls";
import { GetFilter } from "../../containers/pettyCash/components/filter/filters";
import { SetMessage } from "../../assets/errorMessages";
import {
  defaultNormalizerWithSeparateMetaObj,
  fetchAllPages
} from "../../assets/fetchAllPageTogether";
import { CUSTODIAN_CHANGE_STATE_MODES } from "../../constants/pettycash";

export function* pettyCashierWatcherPettyCash() {
  yield takeLatest(types.PETTY_CASHIER_GET_PETTY_CASH_REQUEST, get);
  yield takeLatest(types.PETTY_CASHIER_GET_PETTY_CASH_ITEMS_REQUEST, getItems);
  yield takeLatest(types.PETTY_CASH_STORE_REQUEST, store);
  yield takeLatest(types.PETTY_CASH_UPDATE_REQUEST, update);
  yield takeLatest(types.PETTY_CASH_UPDATE_INFO_REQUEST, updateInfo);
  yield takeLatest(types.PETTY_CASH_DETAIL_REQUEST, detail);
  yield takeLatest(types.PETTY_CASH_DETAIL_FILTER_REQUEST, detailFilter);
  yield takeLatest(types.PETTY_CASHIER_GET_LIST_PETTY_CASH_REQUEST, list);
  yield takeLatest(
    types.PETTY_CASHIER_CHANGE_STATE_PETTY_CASH_REQUEST,
    changeState
  );
  yield takeLatest(types.REMOVE_PETTY_CASH_REQUEST, remove);
}

async function fetchGet(id) {
  return PettyCashApi.get(id);
}

function* get(action) {
  try {
    const response = yield call(fetchGet, action.id);
    yield put(
      PettyCashierPettyCashAction.getRequestSuccess(response.data.data)
    );
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierPettyCashAction.getRequestFailure(message));
  }
}

async function fetchItems(id, pageNum) {
  return PettyCashApi.getItems(id, pageNum);
}

function* getItems(action) {
  try {
    const response = yield call(fetchItems, action.id, action.pageNum);
    yield put(
      PettyCashierPettyCashAction.getItemsRequestSuccess(response.data)
    );
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PettyCashierPettyCashAction.getItemsRequestFailure());
  }
}

async function fetchList(pageNumber = null, filters = {}, perPage = 100) {
  return PettyCashApi.getList(pageNumber, filters, perPage);
}

const listNormalizer = response => {
  const { data, ...meta } = response["data"];
  return { data, meta };
};

function* list(action) {
  try {
    if (action.getAllPages) {
      const response = yield fetchAllPages(
        fetchList,
        action.filters,
        listNormalizer,
        null,
        true
      );
      yield put(
        PettyCashierPettyCashAction.getListSuccess({ data: response.data })
      );
    } else {
      const response = yield call(
        fetchList,
        action.pageNumber,
        action.filters,
        15
      );
      yield put(PettyCashierPettyCashAction.getListSuccess(response.data.data));
    }
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierPettyCashAction.getListFailure(message));
  }
}

async function fetchStore(data) {
  return PettyCashApi.store(data);
}

function* store(action) {
  try {
    const response = yield call(fetchStore, action.data);
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
    yield put(PettyCashierPettyCashAction.storeSuccess());
    yield put(
      replace({
        pathname: `${SUMMARY_PETTY_CASH_PETTY_CASHIER}/${response.data.data.id}`,
        state: { from: "/" }
      })
    );
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierPettyCashAction.storeFailure());
  }
}

async function fetchUpdate(action) {
  return PettyCashApi.update(action.id, action.data);
}

function* update(action) {
  try {
    yield call(fetchUpdate, action);
    yield put(PettyCashierPettyCashAction.updateSuccess());
    yield put(goBack());
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierPettyCashAction.updateFailure());
  }
}

async function fetchUpdateInfo(action) {
  return PettyCashApi.updateInfo(action.id, action.data);
}

function* updateInfo(action) {
  try {
    const response = yield call(fetchUpdateInfo, action);
    yield put(
      PettyCashierPettyCashAction.updateInfoSuccess(response.data.data)
    );
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierPettyCashAction.updateInfoFailure());
  }
}

async function fetchChangeState(id, data, func) {
  switch (func) {
    case CUSTODIAN_CHANGE_STATE_MODES.RETURN:
      return PettyCashApi.sendBack(id);
    case CUSTODIAN_CHANGE_STATE_MODES.REQUEST_RETURN:
      return PettyCashApi.sendRequestBack(id, data);
    case CUSTODIAN_CHANGE_STATE_MODES.SEND:
      return PettyCashApi.sendForward(id);
  }
}

function* changeState(action) {
  try {
    const response = yield call(
      fetchChangeState,
      action.id,
      action.data,
      action.func
    );
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const responseReq = yield call(fetchGet, action.id);
    yield put(
      PettyCashierPettyCashAction.changeStateSuccess(responseReq.data.data)
    );
    yield put(PettyCashAction.reasonCloseModal());
    yield put(PettyCashAction.closeConfirm());
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierPettyCashAction.changeStateFailure());
  }
}

async function fetchRemove(id) {
  return PettyCashApi.remove(id);
}

function* remove(action) {
  const history = createBrowserHistory();
  try {
    const response = yield call(fetchRemove, action.id);
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    if (action.goBack) {
      if (history.location.state && history.location.state.from) {
        yield put(push(history.location.state.from));
      } else {
        yield put(goBack());
      }
    }
    yield put(PettyCashierPettyCashAction.removeSuccess());
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierPettyCashAction.removeFailure());
  }
}

async function fetchDetail(pageNum, id) {
  return PettyCashApi.getDetail(id, pageNum);
}

// function* fetchAllPages(request, id, key) {
//   let pageNum = 1;
//   let response = yield call(request, id, pageNum);
//   let responseData = response.data.data;
//   let detailData = key ? responseData[key] : responseData;
//   let items = [...detailData.data];
//   const regex = new RegExp(`${PETTY_CASH_PETTY_CASHIER}` + `(/\[0-9]+)?$`);
//   while (
//     detailData.current_page < detailData.last_page &&
//     regex.test(document.location.pathname)
//   ) {
//     pageNum = pageNum + 1;
//     response = yield call(request, id, pageNum);
//     responseData = response.data.data;
//     detailData = key ? responseData[key] : responseData;
//     items = [...items, ...detailData.data];
//   }
//   return {
//     ...responseData,
//     data: items
//   };
// }

const normalizerForDetailReq = response => {
  const { data, ...meta } = response.data.items;
  return { data, meta };
};

const otherDataForDetailReq = response => {
  return { ...response.data.data };
};

function* detail(action) {
  try {
    const regex = new RegExp(`${PETTY_CASH_PETTY_CASHIER}` + `(/\[0-9]+)?$`);
    const response = yield fetchAllPages(
      fetchDetail,
      action.id,
      normalizerForDetailReq,
      otherDataForDetailReq,
      regex.test(document.location.pathname)
    );
    yield put(PettyCashierPettyCashAction.getDetailSuccess(response));

    // let filters = queryString.parse(document.location.search);
    // if (filters.start_date || filters.end_date) {
    //   yield put(
    //     PettyCashierPettyCashAction.detailFilter(action.id, action.pageNum)
    //   );
    // }
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierPettyCashAction.getDetailFailure(message));
  }
}

async function fetchDetailFilter(pageNum, data) {
  const filter = { ...data, ...GetFilter() };
  return PettyCashApi.detailFilter(filter, pageNum);
}

function* detailFilter(action) {
  try {
    const regex = new RegExp(`${PETTY_CASH_PETTY_CASHIER}` + `(/\[0-9]+)?$`);
    const response = yield fetchAllPages(
      fetchDetailFilter,
      action.data,
      defaultNormalizerWithSeparateMetaObj,
      null,
      regex.test(document.location.pathname)
    );
    // const filterResponse = yield fetchAllPages(fetchDetailFilter, action.id);
    yield put(PettyCashierPettyCashAction.detailFilterSuccess(response));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierPettyCashAction.detailFilterFailure(message));
  }
}
